import React from "react";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Chip from "@mui/material/Chip";

import PageTitle from "../components/PageTitle";
import AdminTimesheetsDetailRow from "./AdminTimesheetsDetailRow";
import dayjs from "../../common/date";
import { formatShortDate, calculateTotalNumberOfHoursForTimesheet } from "../../common/utils";
import { backgrounds, borders } from "../../theme/theme";

function AdminTimesheetsView(props: any) {
  const { selectedTimesheet, isHideHeader = false } = props;

  if (!selectedTimesheet) {
    return null;
  }

  // Calculate total hours
  const totalHours = calculateTotalNumberOfHoursForTimesheet(
    selectedTimesheet.details,
    selectedTimesheet.timeFormat
  );

  // When used embedded (isHideHeader=true), show plain text for easy copy/paste
  if (isHideHeader) {
    const timesheetText = selectedTimesheet.details
      .map((row: { date: string; numberOfHours: string }) => {
        const date = dayjs(row.date).utc().format("ddd MMM D YYYY");
        return `${date}\t${row.numberOfHours}`;
      })
      .join("\n");

    return (
      <Box sx={{ mb: 2 }}>
        <Typography variant="body2" sx={{ fontWeight: 600, mb: 0.5 }}>
          {formatShortDate(selectedTimesheet.startDate)} - {formatShortDate(selectedTimesheet.endDate)} ({totalHours} hrs)
        </Typography>
        <pre style={{ margin: 0, fontFamily: "monospace", fontSize: "12px", whiteSpace: "pre-wrap" }}>
          {timesheetText}
        </pre>
      </Box>
    );
  }

  // Full page view with header
  return (
    <div>
      <PageTitle>Timesheet #{selectedTimesheet.id}</PageTitle>

      <Box sx={{ mb: 3, p: 2, backgroundColor: backgrounds.page, borderRadius: 1 }}>
        <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1, color: "text.secondary" }}>
          Timesheet Info
        </Typography>
        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2 }}>
          <Typography variant="body2">
            <strong>Period:</strong> {formatShortDate(selectedTimesheet.startDate)} - {formatShortDate(selectedTimesheet.endDate)}
          </Typography>
          <Typography variant="body2">
            <strong>Format:</strong> {selectedTimesheet.timeFormat}
          </Typography>
          <Typography variant="h3">
            <strong>Total Hours:</strong> {totalHours}
          </Typography>
          <Typography variant="body2">
            <strong>Status:</strong>{" "}
            <Chip
              label={selectedTimesheet.submittedAt ? "Submitted" : "Draft"}
              size="small"
              color={selectedTimesheet.submittedAt ? "success" : "default"}
            />
          </Typography>
        </Box>
      </Box>

      <Typography variant="h6" sx={{ mb: 2, fontWeight: 500 }}>
        Daily Entries
      </Typography>
      <Paper variant="outlined" sx={{ overflow: "hidden" }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            py: 1.5,
            px: 1.5,
            backgroundColor: backgrounds.page,
            borderBottom: `2px solid ${borders.light}`,
          }}
        >
          <Typography variant="body2" sx={{ fontWeight: 600 }}>Date</Typography>
          <Typography variant="body2" sx={{ fontWeight: 600 }}>Hours</Typography>
        </Box>
        {selectedTimesheet.details.map(AdminTimesheetsDetailRow)}
      </Paper>
    </div>
  );
}

export default AdminTimesheetsView;
